import React, { useEffect } from "react";
import cesiumNavMixin from "@znemz/cesium-navigation";
import "./addcesiumnavigation.css";

export const AddCesiumNavigation = ({rfcs}) => {

  useEffect(() => {
    if (rfcs.current && rfcs.current.cesiumElement) {
      // ナビゲーションボタンの追加
      if (!cesiumNavMixin) {
        console.error("cesiumNavMixin is undefined");
      } else {
        rfcs.current.cesiumElement.extend(cesiumNavMixin, {});
      }

      // // 以下のオプションについて改良中の模様。様子見。
      //     const navoptions = {};
      // navoptions.defaultResetView = Rectangle.fromDegrees(135, 35, 134, 34);
      // navoptions.enableCompass= true;
      // navoptions.enableZoomControls= true;
      // navoptions.enableDistanceLegend= true;
      // navoptions.enableCompassOuterRing= true;
      // navoptions.resetTooltip = "リセット";
      // navoptions.zoomInTooltip = "拡大";
      // navoptions.zoomOutTooltip = "縮小";
      // new CesiumNavigation(rfcs1.current.cesiumElement, navoptions);

      return () => {
        rfcs.current.cesiumElement.cesiumNavigation.destroy();
      };
    }
  }, []);
  return <>
  </>
}